module.exports = __webpack_public_path__ + "static/img/tit3.7ef7b70e.png";